import React from 'react';
import { NavigationTabLink } from 'modules/ui';

export default function TalentProfileTabs() {
  return (
    <>
      <NavigationTabLink end to="/profile/edit">
        Personal Info
      </NavigationTabLink>
      <NavigationTabLink end to="/profile/edit/professional-info">
        Professional Info
      </NavigationTabLink>
      <NavigationTabLink end to="/profile/edit/skills">
        Your Skills
      </NavigationTabLink>
      <NavigationTabLink end to="/profile/edit/samples">
        Samples
      </NavigationTabLink>
      <NavigationTabLink end to="/profile/edit/agents-and-managers">
        Agents & Managers
      </NavigationTabLink>
    </>
  );
}
